__turbopack_context__.v({
  "benefitItem": "Gn8s2W_benefitItem",
  "benefitsList": "Gn8s2W_benefitsList",
  "closeButton": "Gn8s2W_closeButton",
  "descriptionText": "Gn8s2W_descriptionText",
  "fallbackContent": "Gn8s2W_fallbackContent",
  "footerWrapper": "Gn8s2W_footerWrapper",
  "gradientFade": "Gn8s2W_gradientFade",
  "headerSection": "Gn8s2W_headerSection",
  "headerThumbnail": "Gn8s2W_headerThumbnail",
  "headerTitle": "Gn8s2W_headerTitle",
  "modalContainer": "Gn8s2W_modalContainer",
  "modalContent": "Gn8s2W_modalContent",
  "sectionImage": "Gn8s2W_sectionImage",
  "sectionItem": "Gn8s2W_sectionItem",
  "sectionText": "Gn8s2W_sectionText",
  "sectionTitle": "Gn8s2W_sectionTitle",
  "sectionsContainer": "Gn8s2W_sectionsContainer",
  "stickyFooter": "Gn8s2W_stickyFooter",
  "thumbnailPlaceholder": "Gn8s2W_thumbnailPlaceholder",
});
